import React from 'react';
import TagManager from 'react-gtm-module';
import './App.css';
const phone = "+91 94940 01800";
  const tel = "tel:+919494001800";
  const whatsapp = "https://wa.me/919494001800";
  const map = "https://maps.app.goo.gl/EeASJQTshMaWHxjQ6";
  const logo = "logo.png";
  const heroImage = "https://images.unsplash.com/photo-1515377905703-c4788e51af15?auto=format&fit=crop&w=1400&q=80";
  const ambienceImage = "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?auto=format&fit=crop&w=1200&q=80";
  const therapyImage = "https://lh3.googleusercontent.com/p/AF1QipMtRKdbBz-shkj1eCTIJgyVUo4aamPQnDi3ozAk=w243-h304-n-k-no-nu";
  const jacuzziImage = "https://elements-resized.envatousercontent.com/envato-dam-assets-production/EVA/TRX/10/c0/d9/9c/11/v1_E10/E1058UKO.jpg?w=1600&cf_fit=scale-down&q=85&format=auto&s=b38a816062910618f5b83a0cd53047136690ec1d006553e4d061e470203d875a";
  const hotStoneImage = "https://elements-resized.envatousercontent.com/envato-dam-assets-production/68c64359-0bce-4cc4-9e59-c7eb14771b35/6bceb4e4-359c-4933-beb0-d3d579d53d6c.jpg?w=1600&cf_fit=scale-down&q=85&format=auto&s=62ec7308c88949e16eac61fc5f38f1a4d614c6ac714cc15f7c63c564e9231138";
  const balineseImage = "https://elements-resized.envatousercontent.com/envato-dam-assets-production/EVA/TRX/43/05/93/b0/da/v1_E10/E109YCYR.jpg?w=1600&cf_fit=scale-down&q=85&format=auto&s=a5d87783f54ad5d62eab56f36f27c65ad77db02f8bd078d69a43d4e13e9a61a6";
  const roomImage = "https://lh3.googleusercontent.com/p/AF1QipNxVHtpzmA2SXcPHIwgshjjmTyQCzhcLoleYcMX=s680-w680-h510-rw";

  const services = [
    {
      title: "Deep Tissue Massage",
      desc: "Targets deep muscle tension, chronic pain & body stiffness — most booked massage in Guntur",
      image: therapyImage,
    },
    {
      title: "Swedish Massage",
      desc: "Gentle, full-body relaxation therapy perfect for first-time spa visitors in Guntur",
      image: heroImage,
    },
    {
      title: "Aromatherapy",
      desc: "Healing essential oil massage therapy for mental stress and physical fatigue relief",
      image: ambienceImage,
    },
    {
      title: "Balinese Massage",
      desc: "Traditional combination massage technique for deep, restorative full-body relaxation",
      image: balineseImage,
    },
    {
      title: "Hot Stone Therapy",
      desc: "Warm stone massage that relieves stiffness, improves circulation and eases tension",
      image: hotStoneImage,
    },
    {
      title: "Jacuzzi Bath",
      desc: "Premium hydrotherapy experience — the ultimate spa luxury in Guntur",
      image: jacuzziImage,
    },
  ];

  const reasons = [
    "Same-day spa booking available in Guntur",
    "Prime location — easily accessible from all areas of Guntur",
    "Spotless, premium private spa rooms",
    "Certified, professional massage therapists",
    "Best spa deals and offers in Guntur",
    "Affordable luxury spa experience in Guntur",
    "Rated among the top massage centers in Guntur",
  ];

  const reviews = [
    {
      name: "Happy Priya R., Guntur",
      text: "Hands down the best spa in Guntur. The deep tissue massage was incredible — clean rooms, professional staff, and very calming atmosphere.",
    },
    {
      name: "Kiran M., Repeat Customer",
      text: "Booked same day and got an instant slot. Best massage center in Guntur — easy to find near Gorantla and very affordable with the offers.",
    },
    {
      name: "Sneha T., Weekend Visitor",
      text: "Best spa in Guntur for stress relief, no doubt. The Swedish massage and aromatherapy combo was exactly what I needed. Highly recommend!",
    },
  ];

  TagManager.initialize({
    gtmId: 'GTM-539VRF9F',
  });

function App() {
  return (
    <div className="min-h-screen bg-[#f7f2eb] text-stone-900">
      <header className="sticky top-0 z-50 border-b border-stone-200/80 bg-white/90 backdrop-blur-xl">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 lg:px-8">
          <div>
            <p className="text-[11px] font-semibold uppercase tracking-[0.35em] text-amber-700">Luxury Spa in Guntur</p>
            <h1 className="text-lg font-bold sm:text-xl">Booking Available with Instant Discount</h1>
          </div>
          <div className="hidden items-center gap-3 sm:flex">
            <a
              href={whatsapp}
              className="rounded-2xl border border-stone-300 bg-white px-4 py-2 text-sm font-semibold text-stone-700 hover:bg-stone-100"
            >
              WhatsApp
            </a>
            <a
              href={tel}
              className="rounded-2xl bg-stone-900 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:opacity-90"
            >
              Call Now
            </a>
          </div>
        </div>
      </header>

      <section className="relative overflow-hidden">
        <div className="absolute inset-0">
          <img src={heroImage} alt="Luxury spa ambiance" className="h-full w-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-r from-[#41180C]/10 via-[#41180C]/10 to-[#41180C]/10" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#41180C]/10 to-transparent" />
        </div>

        <div className="relative mx-auto grid max-w-7xl gap-10 px-4 py-14 text-white lg:grid-cols-[1.1fr_0.9fr] lg:px-8 lg:py-24">
          <div className="max-w-2xl">
            <a href="https://book.olivespaGuntur.com">
              <img src={logo} alt="Divine Wellness Spa Logo" className="h-24 w-30 mb-3" />
            </a>
            <div className="mb-5 inline-flex items-center rounded-full border border-white/20 bg-white/10 px-4 py-1.5 text-xs font-medium tracking-wide text-stone-100 shadow-sm backdrop-blur">
              Best Spa in Guntur • Same Day Booking Available • Upto 40% Off
            </div>
            <h2 className="text-4xl font-extrabold leading-tight sm:text-5xl lg:text-6xl">
              Best Luxury Spa in Guntur - Upto 40% Off on All  Massage Services
            </h2>
            <p className="mt-5 max-w-xl text-base leading-7 text-stone-200 sm:text-lg">
              Looking for the <b>best spa in Guntur?</b> Divine Wellness Spa is Guntur's most trusted destination for premium massage therapy 
              and full body relaxation. Whether you need a <b>deep tissue massage</b>, a calming <b>aromatherapy session</b>, or a complete 
              <b>spa day in Guntur</b> — we've got you covered. Enjoy up to 40% off on all services, with same-day spa booking available right now.
              Guntur — we've got you covered. Enjoy <b>up to 40% off</b> on all services, with <b>same-day spa booking</b> available right now.
            </p>
            <div className="mt-7 grid gap-3 sm:grid-cols-3">
              <div className="rounded-2xl border border-white/15 bg-white/10 p-4 backdrop-blur-md">
                <p className="text-xs uppercase tracking-[0.2em] text-stone-300">Open Daily</p>
                <p className="mt-1 text-lg font-bold">9 AM – 10 PM</p>
              </div>
              <div className="rounded-2xl border border-white/15 bg-white/10 p-4 backdrop-blur-md">
                <p className="text-xs uppercase tracking-[0.2em] text-stone-300">Location</p>
                <p className="mt-1 text-lg font-bold">Gorantla, Andhra Pradesh</p>
              </div>
              <div className="rounded-2xl border border-white/15 bg-white/10 p-4 backdrop-blur-md">
                <p className="text-xs uppercase tracking-[0.2em] text-stone-300">Best For</p>
                <p className="mt-1 text-lg font-bold">Instant Phone Bookings</p>
              </div>
            </div>
            <div className="mt-8 flex flex-col gap-3 sm:flex-row">
              <a
                href={tel}
                className="inline-flex items-center justify-center rounded-2xl bg-white px-6 py-4 text-base font-bold text-stone-900 shadow-lg transition hover:translate-y-[-1px]"
              >
                📞 Call Now for Instant Slot
              </a>
              <a
                href={whatsapp}
                className="inline-flex items-center justify-center rounded-2xl border border-white/20 bg-white/10 px-6 py-4 text-base font-bold text-white backdrop-blur transition hover:bg-white/15"
              >
                💬 WhatsApp Booking
              </a>
            </div>
          </div>

          <div className="lg:pl-8">
            <div className="overflow-hidden rounded-[2rem] border border-white/15 bg-white/95 text-stone-900 shadow-2xl backdrop-blur">
              <img src={ambienceImage} alt="Spa room interior" className="h-56 w-full object-cover" />
              <div className="p-6">
                <div className="flex items-start justify-between gap-4">
                  <div>
                    {/* <p className="text-sm font-semibold uppercase tracking-[0.2em] text-amber-700">Why this page converts</p> */}
                    <h3 className="mt-2 mb-2 text-2xl font-extrabold">Why Divine Wellness Spa is the Best Spa in Guntur</h3>
                    <p className="text-sm text-black">Thousands of customers across Guntur trust Divine Wellness Spa for premium relaxation, certified massage therapy, and unbeatable spa deals in Guntur.</p>
                  </div>
                  {/* <div className="rounded-full bg-emerald-100 px-3 py-1 text-sm font-semibold text-emerald-700">High Intent</div> */}
                </div>
                <div className="mt-6 grid gap-3">
                  {[
                    "Instant same-day spa booking in Guntur",
                    "Prime location — Gorantla, heart of Guntur",
                    "Full body massage, deep tissue & Swedish massage available",
                    "Up to 40% off on all massage therapy services",
                    "Clean, hygienic, and fully private spa rooms",
                    "Certified and experienced massage therapists in Guntur",
                    "Easy mobile-friendly booking - call or WhatsApp",
                  ].map((item) => (
                    <div key={item} className="rounded-2xl border border-stone-200 bg-stone-50 px-4 py-3 text-sm font-medium text-stone-700">
                      {item}
                    </div>
                  ))}
                </div>
                <div className="mt-6 rounded-2xl bg-[#41180C] p-5 text-white">
                  <p className="text-sm text-stone-300">Direct booking line</p>
                  <a href={tel} className="mt-1 block text-2xl font-extrabold tracking-wide hover:underline">
                    {phone}
                  </a>
                  <p className="mt-2 text-sm text-stone-300">Book the best spa experience in Guntur today — limited offer, don't miss out</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 py-16 lg:px-8">
        <div className="grid gap-8 lg:grid-cols-[1.02fr_0.98fr]">
          <div>
            {/* <p className="text-sm font-semibold uppercase tracking-[0.25em] text-amber-700">Why customers choose us</p> */}
            <h3 className="mt-3 text-3xl font-extrabold">Real Relief. Real Relaxation. Right Here in Guntur</h3>
            <p className="mt-4 max-w-2xl text-base leading-7 text-stone-600">
            Whether you're dealing with stress, chronic muscle tension, or just need a well-deserved break — Divine Wellness Spa Guntur is where the city comes to truly feel better. As the most trusted massage spa in Guntur, we make it easy to book a full body massage in Guntur, walk in the same day, and leave completely refreshed.
            </p>
            <div className="mt-8 grid gap-4 sm:grid-cols-1">
              {reasons.map((item) => (
                <div key={item} className="rounded-[1.5rem] border border-stone-200 bg-white p-5 shadow-sm">
                  <div className="text-lg font-bold">✓ {item}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="overflow-hidden rounded-[2rem] border border-stone-200 bg-white shadow-sm">
            <img src={roomImage} alt="Premium massage room" className="h-72 w-full object-cover" />
            <div className="p-6">
              {/* <p className="text-sm font-semibold uppercase tracking-[0.25em] text-amber-700">Quick details</p> */}
              <h4 className="mt-2 text-2xl font-extrabold">Book the Best Spa in Guntur — Right Now</h4>
              <div className="mt-6 space-y-4 text-sm leading-7 text-stone-700">
                <div className="rounded-2xl bg-stone-50 p-4"><strong>Phone:</strong> {phone}</div>
                <div className="rounded-2xl bg-stone-50 p-4"><strong>Timings:</strong> Open daily from 9:00 AM to 10:00 PM</div>
                <div className="rounded-2xl bg-stone-50 p-4"><strong>Address:</strong> no 57, Revenue ward, 7-210, Gorantla, Andhra Pradesh 522034</div>
                <div className="rounded-2xl bg-stone-50 p-4"><strong>Special Offer:</strong> Up to 40% Off on All Massage & Spa Services in Guntur</div>
              </div>
              <div className="mt-6 flex flex-col gap-3 sm:flex-row">
                <a href={tel} className="inline-flex flex-1 items-center justify-center rounded-2xl bg-[#41180C] px-5 py-4 font-bold text-white hover:opacity-90">Call Now</a>
                <a href={map} className="inline-flex flex-1 items-center justify-center rounded-2xl border border-stone-300 px-5 py-4 font-bold text-stone-800 hover:bg-stone-50">Get Directions</a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="border-y border-stone-200 bg-white">
        <div className="mx-auto max-w-7xl px-4 py-16 lg:px-8">
          <div className="max-w-2xl">
            <p className="text-sm font-semibold uppercase tracking-[0.25em] text-amber-700">Popular therapies</p>
            <h3 className="mt-3 text-3xl font-extrabold">Best Massage Therapies in Guntur — All Under One Roof</h3>
            <p className="mt-4 text-base leading-7 text-stone-600">
            Divine Wellness Spa offers Guntur's most complete range of professional massage therapies. Every service is available at up to 40% off — making us the most affordable luxury spa in Guntur.
            </p>
          </div>
          <div className="mt-8 grid gap-5 md:grid-cols-2 xl:grid-cols-3">
            {services.map((service) => (
              <div key={service.title} className="overflow-hidden rounded-[1.75rem] border border-stone-200 bg-stone-50 shadow-sm">
                <img src={service.image} alt={service.title} className="h-52 w-full object-cover" />
                <div className="p-6">
                  <h4 className="text-xl font-bold">{service.title}</h4>
                  <p className="mt-3 text-sm leading-7 text-stone-600">{service.desc}</p>
                  <a href={tel} className="mt-5 inline-flex rounded-xl bg-[#41180C] px-4 py-2 text-sm font-bold text-white hover:opacity-90">Call for Availability</a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 py-16 lg:px-8">
        <div className="grid gap-8 lg:grid-cols-2">
          <div className="overflow-hidden rounded-[2rem] bg-[#41180C] text-white shadow-lg">
            <img src={jacuzziImage} alt="Jacuzzi and relaxation setup" className="h-72 w-full object-cover opacity-80" />
            <div className="p-8">
              <p className="text-sm font-semibold uppercase tracking-[0.25em] text-stone-300">Trust block</p>
              <h3 className="mt-3 text-3xl font-extrabold">What Guntur Clients Say About Divine Wellness Spa</h3>
              <div className="mt-6 space-y-2 text-sm leading-7 text-stone-200">
                <p>Customers consistently highlight our clean, well-maintained rooms, professional therapists, and a calm, premium atmosphere that helps them truly relax.</p>
                <p>Many visitors choose us for quick, same-day bookings and easy accessibility near Gorantla, making it convenient for both planned visits and last-minute appointments.</p>
                <p>From deep tissue relief to soothing aromatherapy, clients appreciate the variety of therapies and the attention to detail that makes each session feel worth it.</p>
              </div>
            </div>
          </div>

          <div>
            <h3 className="mt-3 text-3xl font-extrabold">What Our Clients Say About Us</h3>
            <div className="mt-6 grid gap-4">
              {reviews.map((review) => (
                <div key={review.name} className="rounded-[1.75rem] border border-stone-200 bg-white p-6 shadow-sm">
                  <div className="text-lg">⭐⭐⭐⭐⭐</div>
                  <p className="mt-3 text-sm leading-7 text-stone-600">“{review.text}”</p>
                  <p className="mt-4 font-bold text-stone-800">{review.name}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="bg-[#efe4d5]">
        <div className="mx-auto max-w-7xl px-4 py-16 lg:px-8">
          <div className="grid gap-8 lg:grid-cols-[0.95fr_1.05fr]">
            <div>
              <p className="text-sm font-semibold uppercase tracking-[0.25em] text-amber-700">Visit Us Now</p>
              <h3 className="mt-3 text-3xl font-extrabold">Conveniently Located — Best Spa Near You in Guntur</h3>
              <p className="mt-4 text-base leading-7 text-stone-700">
              Finding a trusted spa near you in Guntur just got easier. Divine Wellness Spa is conveniently located in a prime area of Guntur, making it easily accessible from nearby towns and villages. Whether you're coming from Vanavolu, Budili, Buganipalle, Jowkuledudinne, Katepalle, or surrounding areas, reaching us is quick and hassle-free.
              </p>
              <div className="mt-6 rounded-[1.75rem] bg-white p-6 shadow-sm">
                <p className="text-sm text-stone-500">Address</p>
                <p className="mt-2 text-lg font-bold">no 57, Revenue ward, 7-210, Gorantla, Andhra Pradesh 522034</p>
                <p className="mt-3 text-sm leading-7 text-stone-600">We rank for: "best spa near me Guntur"  •  "body massage Guntur"  •  "massage center near Gorantla Guntur"</p>
                <div className="mt-5 flex flex-col gap-3 sm:flex-row">
                  <a href={map} className="inline-flex items-center justify-center rounded-2xl border border-stone-300 px-5 py-3 font-bold text-stone-800 hover:bg-stone-50">Open in Maps</a>
                  <a href={tel} className="inline-flex items-center justify-center rounded-2xl bg-[#41180C] px-5 py-3 font-bold text-white hover:opacity-90">Call Before Visit</a>
                </div>
              </div>
            </div>

            <div className="overflow-hidden rounded-[2rem] bg-white shadow-sm">
              <img src={therapyImage} alt="Spa therapy experience" className="h-72 w-full object-cover" />
              <div className="p-8">
                <p className="text-sm font-semibold uppercase tracking-[0.25em] text-amber-700">Your Visit Made Simple</p>
                <h3 className="mt-3 text-3xl font-extrabold">Relaxation Starts the Moment You Reach Us</h3>
                <ol className="mt-6 space-y-2 text-sm leading-7 text-stone-700">
                  <li><strong>1.</strong> Conveniently situated on Gorantla Road, making it quick to reach from anywhere in the city.</li>
                  <li><strong>2.</strong> Well-maintained rooms, soothing interiors, and a peaceful setup that helps you unwind instantly.</li>
                  <li><strong>3.</strong> Trained experts who understand body relaxation, pressure points, and personalized care.</li>
                  <li><strong>4.</strong> Call or WhatsApp for instant slot confirmation, or visit directly for same-day service.</li>
                  <li><strong>5.</strong> From Deep Tissue and Swedish to Aromatherapy and Jacuzzi sessions — choose what suits your need.</li>
                  <li><strong>6.</strong> From Deep Tissue and Swedish to Aromatherapy and Jacuzzi sessions — choose what suits your need.</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 py-16 lg:px-8">
        <div className="overflow-hidden rounded-[2rem] bg-gradient-to-r from-[#41180C] via-[#41180C] to-[#41180C] shadow-xl">
          <div className="grid lg:grid-cols-[1.15fr_0.85fr]">
            <div className="p-8 text-white lg:p-12">
              <p className="text-sm font-semibold uppercase tracking-[0.25em] text-stone-300">Relax More. Pay Less. Feel Better.</p>
              <h3 className="mt-3 text-3xl font-extrabold sm:text-4xl">Book the Best Spa in Guntur Today — Limited Slots Available</h3>
              <p className="mt-4 max-w-2xl text-base leading-7 text-stone-200">
              Don't miss Guntur's best spa deal. Visit Divine Wellness Spa Guntur and enjoy a world-class full body massage, deep tissue therapy, or aromatherapy session — all at up to 40% off. Same-day bookings available. Call now and secure your slot at the #1 luxury spa in Guntur.
              </p>
              <div className="mt-8 flex flex-col gap-3 sm:flex-row">
                <a href={tel} className="inline-flex items-center justify-center rounded-2xl bg-white px-6 py-4 text-base font-bold text-stone-900 hover:translate-y-[-1px]">📞 Call Now</a>
                <a href={whatsapp} className="inline-flex items-center justify-center rounded-2xl border border-white/20 bg-white/10 px-6 py-4 text-base font-bold text-white hover:bg-white/15">💬 WhatsApp Us</a>
              </div>
            </div>
            <div className="min-h-[260px] lg:min-h-full">
              <img src={ambienceImage} alt="Elegant spa space" className="h-full w-full object-cover" />
            </div>
          </div>
        </div>
      </section>

      <footer className="border-t border-stone-200 bg-white">
        <div className="mx-auto flex max-w-7xl flex-col gap-4 px-4 py-6 text-sm text-stone-500 sm:flex-row sm:items-center sm:justify-between lg:px-8">
          <p>© 2026 Divine Wellness Spa Guntur. All rights reserved. Designed By <a href="kishkindhamedia.com">Kishkindha Media</a></p>
        </div>
      </footer>

      <div className="fixed inset-x-0 bottom-0 z-50 border-t border-stone-200 bg-white/95 p-3 shadow-2xl backdrop-blur sm:hidden">
        <div className="mx-auto flex max-w-lg gap-3">
          <a href={tel} className="flex-1 rounded-2xl bg-[#41180C] px-4 py-4 text-center text-base font-bold text-white">
            📞 Call Now
          </a>
          <a href={map} className="flex-1 rounded-2xl border border-stone-300 px-4 py-4 text-center text-base font-bold text-stone-800">
            📍 Visit Store
          </a>
        </div>
      </div>
    </div>
  );
}

export default App;
